
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { ProductData } from '../types';

@Component({})
export default class ProductButton extends Vue {
	@Prop() item!: ProductData;
	@Prop() selected!: boolean;

	@Emit()
	private toggle(): boolean {
		this.selected = !this.selected;
		return this.selected;
	}
}
